var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-width"},[_c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeName == 'protein'),expression:"activeName == 'protein'"}]},[_c('SubmitProteinBlock',{attrs:{"homeBlock":'Yes'}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }